import _sfc_main from "./BuyBoxProductDescription2.mjs";
/* empty css                           */
import _export_sfc from "../../../../_virtual/_plugin-vue_export-helper.mjs";
const BuyBoxProductDescription = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-e91e265e"]]);
export {
  BuyBoxProductDescription as default
};
//# sourceMappingURL=BuyBoxProductDescription.mjs.map
